import React from "react";

export const NoItemCard = () => {
	return (
		<div className="flex border w-full h-full items-center justify-center font-light p-4 rounded-md">
			No Item
		</div>
	);
};
